<template>
  <div class="creek-social-container">
    <div class="creek-social-buttons">
      <button @click="facebook()" class="creek-social-button creek-social-button-facebook"><i class="fa fa-facebook"></i> Share</button>
      <button @click="twitter()" class="creek-social-button creek-social-button-twitter"><i class="fa fa-twitter"></i> Tweet</button>
      <button @click="email()" class="creek-social-button creek-social-button-email"><i class="fa fa-envelope"></i> Email</button>
    </div>
    <div class="creek-social-email-box" v-if="ui.emailBox">
      <p>Copy and paste this link into an email:</p>
      <input type="text" id="creek-email-link" :value="shareURL"/>
      <span class="creek-close" @click="email()">Close</span>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'creek-social-buttons',
  props: ['data-link'],
  data () { 
    return {
      ui: {
        emailBox: false
      },
    } 
  },
  methods: {
    open(baseURL, title, width, height){

      var left = (window.innerWidth - width) / 2,
          top = (window.innerHeight - height) / 2,
          options = 'toolbar=0,status=0' +
                    ',top=' + top + 
                    ',left=' + left + 
                    ',width=' + width + 
                    ',height=' + height,
          URL = baseURL + this.shareURLEncoded
    
      window.open(URL, title, options);
    
    },
    facebook() {
      this.open('http://www.facebook.com/sharer.php?u=', 'Facebook', 520, 350);
    },
    twitter() {
      this.open('http://twitter.com/share?url=', 'Twitter', 575, 400);
    },
    email() {
      this.ui.emailBox = this.ui.emailBox ? false : true;
    }
  },
  computed: {
    shareURL(){
      return this.dataLink || window.location;
    },
    shareURLEncoded(){
      return encodeURIComponent(this.shareURL);
    }
  }
}
</script>